import {useState} from 'react'
import {CardHeader} from '../../../components'
import {CompanyModel} from '../../models'
import EditInfoCompanyModal from '../../modals/EditInfoCompanyModal'

interface Props {
    company: CompanyModel
    getData: () => void
}

export default function InfoShowCompanySubpage({company, getData}: Props) {
    const [isOpenModal, setIsOpenModal] = useState(false)

    return (
        <>
            <div className='card'>
                <CardHeader title='Informações da empresa'>
                    <div className='btn-group'>
                        <button
                            onClick={() => {
                                setIsOpenModal(true)
                            }}
                            className='btn btn-sm btn-light-info'
                        >
                            <i className='fa fa-edit'></i>
                            Atualizar dados
                        </button>
                    </div>
                </CardHeader>
                <div className='card-body'>
                    <div className='row mb-5'>
                        <div className='col-12'>
                            <label>Razão Social</label>
                            <h3>{company.nm_company}</h3>
                        </div>
                    </div>
                    <div className='row mb-5'>
                        <div className='col-6'>
                            <label>Nome Fantasia</label>
                            <h3>{company.nm_fantasy}</h3>
                        </div>
                        <div className='col-6'>
                            <label>Telefone</label>
                            <h3>{company.cd_phone_number}</h3>
                        </div>
                    </div>
                    <div className='row mb-5'>
                        <div className='col-5'>
                            <label>CNPJ</label>
                            <h3>{company.cd_cnpj}</h3>
                        </div>
                        <div className='col-5'>
                            <label>E-mail de contato</label>
                            <h3>{company.ds_contact_email ?? 'Não informado'}</h3>
                        </div>
                        <div className='col-2'>
                            <label>Status</label>
                            {company.status ? (
                                <h3 className='text-success'>Ativo</h3>
                            ) : (
                                <h3 className='text-danger'>Inativo</h3>
                            )}
                        </div>
                    </div>
                    <div className='row'>
                        {company.ds_path_social && (
                            <div className='col-6'>
                                <label>Contrato Social</label>
                                <h3>
                                    <a
                                        target='_blank'
                                        rel='noreferrer'
                                        href={company.ds_path_social}
                                    >
                                        Visualizar contrato social
                                    </a>
                                </h3>
                            </div>
                        )}
                        {company.url_person && (
                            <div className='col-6'>
                                <label>Identidade do sócio e/ou procurador representante</label>
                                <h3>
                                    <a target='_blank' rel='noreferrer' href={company.url_person}>
                                        Visualizar Documento
                                    </a>
                                </h3>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <EditInfoCompanyModal
                isOpen={isOpenModal}
                onClose={setIsOpenModal}
                onUpdate={() => getData()}
                company={company}
            />
        </>
    )
}
